import React, { HTMLProps } from 'react';
import MfLinearIndeterminateProgress from './MfLinearIndeterminateProgress';

interface Props extends HTMLProps<HTMLDivElement> {
  loadingText?: string;
}

const MfLinearSimpleProgress = ({ loadingText, style, ...rest }: Props) => (
  <div {...rest} style={{ ...style, padding: '1rem' }}>
    <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
      {loadingText}
    </div>
    <MfLinearIndeterminateProgress />
  </div>
);

MfLinearSimpleProgress.defaultProps = {
  loadingText: 'Загрузка',
};

export default MfLinearSimpleProgress;
